import type { CallToAction } from "@ebay/experience-types-ebay";
import type { PointOfInterest } from "../../@types/mapviewxs";
import type { UnHoverItemEvent } from "../left-rail-item/types";

export interface Input {
  leftRailItems: PointOfInterest[];
  pointsOfInterest: PointOfInterest[];
  isLoading: boolean | undefined;
  prevSelectedItems: number[];
  selectedItems: number[];
  highlightedItem: number | null;
  prevHighlightedItem: number | null;
  showErrorMessage: boolean;
  isLeftRailItemHover: boolean;
  isPreviewCardEnabled: boolean;
  areFiltersActive?: boolean;
  cta?: CallToAction;
  "on-cta-click"?: () => void;
  "on-item-hover"?: (itemIndex: number, listingId?: string) => void;
  "on-unhover-item"?: () => void;
}

export default class extends Marko.Component<Input> {
  onUpdate() {
    if (!this.input.isLeftRailItemHover && this.input.selectedItems !== this.input.prevSelectedItems) {
      this.scrollToSelectedItem();
    }
  }

  onItemHover(itemIndex: number, listingId?: string) {
    this.emit("item-hover", itemIndex, listingId);
  }

  onUnhoverItem(e: UnHoverItemEvent) {
    e?.el.parentElement?.querySelectorAll(".left-rail-item")?.forEach((el: HTMLAnchorElement) => el.blur());
    this.emit("unhover-item");
  }

  onCtaClick() {
    this.emit("cta-click");
  }

  onMount() {
    if (!this.input.isLeftRailItemHover) {
      this.scrollToSelectedItem();
    }
  }

  scrollToSelectedItem() {
    const activeElement = document.querySelectorAll(".left-rail-item__selected")[0];
    if (activeElement) {
      const parentElement = activeElement.parentElement?.parentElement?.parentElement;
      const activeElementPosition = activeElement.getBoundingClientRect().top;
      const parentElementPosition = parentElement?.getBoundingClientRect().top ?? 0;
      const offset = 20;

      parentElement?.scrollIntoView({
        behavior: "instant",
        block: "center",
      });
      parentElement?.scrollBy({
        top: activeElementPosition - parentElementPosition - offset,
        behavior: "smooth",
      });
    }
  }
}
